import type { ITripPnr, ITraveler } from '../types';

export const getPrimaryTravelerFromPnr = (pnr: ITripPnr): ITraveler | undefined =>
  pnr.air?.travelerInfo[0]?.traveler ??
  pnr.hotel?.travelerInfo[0]?.traveler ??
  pnr.car?.travelerInfo[0]?.traveler ??
  pnr.rail?.itineraryDetails?.passengers[0]?.traveler ??
  pnr.misc?.travelerInfo[0]?.traveler ??
  pnr.limo?.travelerInfo[0]?.traveler;
